module.exports = __webpack_public_path__ + "img/google_step_2.ce945a11.jpg";